import CaseManagement from "../Component/CaseManagement";
import { connect } from 'react-redux';
import {
  getUserList,
  getAllCustomerList,
  getGroupList,
  getAllMessages,
  createNewTickets,
  getFranchiseList,
  clearCommercialCustomer,
  clearCustomerDetail,
  getReasonList
} from '../../../Action';


const mapStateToProps = (state) => {
  const { AllMessages, UserList, GroupList, AllCustomer, NewTicket, FranchiseList,getReasons } = state;


  return { AllMessages, UserList, GroupList, AllCustomer, NewTicket, FranchiseList, getReasons }
}
const actionCreators = {
  getAllMessages, getUserList,
  getAllCustomerList, getGroupList,
  createNewTickets, getFranchiseList, clearCommercialCustomer,
  clearCustomerDetail,getReasonList
}
export default (connect(mapStateToProps, actionCreators)(CaseManagement));